import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { LogService } from 'src/app/services/common/log.service';
import { AuthService } from 'src/app/services/app/auth.service';
import { WebNavbarComponent } from '../../front-end/web-components/web-navbar/web-navbar.component';
import { FloatLabel } from 'primeng/floatlabel';
import { InputText } from 'primeng/inputtext';
import { Password } from 'primeng/password';
import { NgxCaptchaModule } from 'ngx-captcha';
import { WebFooterComponent } from '../../front-end/web-components/web-footer/web-footer.component';

@Component({
    standalone: true,
    selector: 'app-blog-login',
    templateUrl: './blog-login.component.html',
    styleUrls: ['./blog-login.component.css'],
    imports: [WebNavbarComponent, FormsModule, ReactiveFormsModule, FloatLabel, InputText, Password, NgxCaptchaModule, WebFooterComponent]
})
export class BlogLoginComponent {

  ErrorMessage: string;
  subscriberLoginGroup: FormGroup;
  googleGroup: FormGroup;
  hide = true;
  selectedValue: string;
  signUpSubscriberID = "";
  loginSubscriberID = "";

  IsNewSubscription = 0;
  InvalidLogin = 0;
  IsPaymentCompleted = 0;

  reCaptchaVerfication = null;

  CaptchaSiteKey = environment.recaptcha.siteKey;
  public captchaIsLoaded = false;
  public captchaSuccess = false;
  public captchaIsExpired = false;
  public captchaResponse?: string;

  public theme: 'light' | 'dark' = 'light';
  public size: 'compact' | 'normal' = 'normal';
  public lang = 'en';
  public type: 'image' | 'audio';

  constructor(private authService: AuthService,
     private router: Router,
     private logService: LogService) {}

  ngOnInit(): void {
    try{
      // var id = sessionStorage.getItem("UserId");
      // if(id == null || id == undefined){
      //   var username = this.cookieService.get('Username');
      //   var password = this.cookieService.get('Password');

      //   if (username != "" && password != "") {
      //     this.subscriberLoginGroup = new FormGroup({
      //       Username: new FormControl(this.encrypt.decryptionAES(username)),
      //       Password: new FormControl(this.encrypt.decryptionAES(password))
      //     });
      //     this.Userlogin(1);
      //   }
      //   else{
           this.initForm();
      //   }
      // }
      // else{
      //   this.router.navigate(
      //     ['view-company'],
      //     { queryParams: { UserId: sessionStorage.getItem("UserId") } }
      //   )
      // }
    }catch(ex){
      this.logService.InsertExceptionLog(ex,"Blog Login","ngOnInit");
      console.log(ex);
    }
  }

  initForm() {
    try{
      this.subscriberLoginGroup = new FormGroup({
        Username: new FormControl('', [Validators.required, Validators.email]),
        Password: new FormControl('', [Validators.required]),
        recaptcha: new FormControl(null),
      });
      this.reCaptchaVerfication = null;
    }catch(ex){
      this.logService.InsertExceptionLog(ex,"Blog Login","initForm");
      console.log(ex);
    }
  }

  Userlogin(IsCookieLogin?) {
    try {
      this.InvalidLogin = 0;

      if(this.reCaptchaVerfication == null && IsCookieLogin == undefined) {
        alert("Please tick I am not a robot!");
      }
      else {
        if (this.subscriberLoginGroup.valid) {
          this.authService.blogLogin(this.subscriberLoginGroup.value).subscribe(
            (result) => {
              if(result.success){
                //sessionStorage.setItem("UserId",result.UserId);
                this.initForm();

                this.router.navigate(
                  ['view-blog'],
                  { queryParams: { UserId: result.userID } }
                );
              }
              else{
                this.InvalidLogin = 1;
              }
            }, (err: Error) => {
              console.log(err.message);
          });
        }
      }
    } catch (ex) {
      this.logService.InsertExceptionLog(ex,"Blog Login","Userlogin");
      console.log(ex);
    }
  }

  handleSuccess(data) {
    this.reCaptchaVerfication = data;
  }

  getErrorMessage() {
    const username = this.subscriberLoginGroup?.get('Username');
    if (!username) {
      return '';
    }
    if (username.hasError('required')) {
      return 'You must enter a value';
    }
    return username.hasError('email') ? 'Not a valid email' : '';
  }
}
